import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

function AsyncModelPicker({ value, onChange }) {
  const perPage = 30;
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef(null);

  const baseURL = process.env.REACT_APP_INVENTORY_API_URL;

  const buildURL = (p=1) => {
    const u = new URL(`${baseURL}/product/model`);
    u.searchParams.set("page", String(p));
    u.searchParams.set("per_page", String(perPage));
    if (q) u.searchParams.set("search", q);
    // keep payload tiny:
    u.searchParams.append("fields[]", "id");
    u.searchParams.append("fields[]", "name");
    u.searchParams.append("fields[]", "long_name");
    u.searchParams.append("fields[]", "product_series.name");
    u.searchParams.append("fields[]", "product_brand.brand.name");
    return u.toString();
  };

  const fetchPage = async (p=1, append=false) => {
    try {
      setLoading(true);
      const res = await fetch(buildURL(p));
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();
      const rows = Array.isArray(json?.data.data) ? json.data.data : (Array.isArray(json) ? json : []);
      console.log({rows});
      setItems(prev => append ? [...prev, ...rows] : rows);
      setHasMore(Boolean(json?.meta?.next_page_url));
      setPage(p);
    } catch (e) {
      toast.error("Gagal memuat model.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchPage(1, false); /* mount */ }, []); // eslint-disable-line
  useEffect(() => {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => fetchPage(1, false), 300);
    return () => clearTimeout(debounceRef.current);
  }, [q]); // eslint-disable-line

  return (
    <div className="space-y-2">
      <input
        className="w-full px-3 py-2 text-sm border rounded-xl"
        placeholder="Cari Model…"
        value={q}
        onChange={(e)=>setQ(e.target.value)}
      />
      <div
        className="h-72 overflow-auto border rounded-xl"
        onScroll={(e) => {
          const el = e.currentTarget;
          if (!loading && hasMore && el.scrollTop + el.clientHeight >= el.scrollHeight - 16) {
            fetchPage(page + 1, true);
          }
        }}
      >
        {items.map(m => (
          <button
            type="button"
            key={m.id}
            onClick={()=>onChange(m)}
            className="w-full text-left px-3 py-2 text-xs hover:bg-neutral-50"
          >
            <div className="font-medium">{m.name}</div>
            <div className="text-neutral-500">{m.long_name}</div>
            <div className="text-[10px] text-neutral-500">
              {m.product_series?.name} • {m.product_brand?.brand?.name}
            </div>
          </button>
        ))}
        {loading && <div className="p-3 text-xs text-neutral-500">Memuat…</div>}
        {!loading && items.length === 0 && <div className="p-3 text-xs text-neutral-500">Tidak ada hasil</div>}
      </div>
    </div>
  );
}

export default AsyncModelPicker;